// extracted by mini-css-extract-plugin
export default {"container":"H2HCard_container__p57ch"};